import { useLocation } from "react-router-dom";
import { CookieConsentBanner } from "@/components/cookie/CookieConsentBanner";
import { CookiePreferencesModal } from "@/components/cookie/CookiePreferencesModal";
import { useCookieConsent } from "@/contexts/CookieConsentContext";

/**
 * Renders cookie banner (only on public routes) and the preferences modal (everywhere).
 * Place once inside BrowserRouter so useLocation works.
 */
export function CookieConsentGate() {
  const location = useLocation();
  const { preferencesOpen, setPreferencesOpen, showBanner } = useCookieConsent();
  const isPublic = !location.pathname.startsWith("/app");

  return (
    <>
      {isPublic && showBanner && <CookieConsentBanner />}
      <CookiePreferencesModal open={preferencesOpen} onOpenChange={setPreferencesOpen} />
    </>
  );
}
